import { Card, CardBody, CardSubtitle } from 'reactstrap';
import PropTypes from 'prop-types';
import Text from '../../common/Text';

const DashCard = ({ children, title, subtitle, actions }) => {
  return (
    <Card>
      <CardBody className="p-4">
        <div className="d-flex">
          <div>
          <Text variant="cardTitle">
  {title}
</Text>
            {subtitle ? <CardSubtitle className="text-muted">{subtitle}</CardSubtitle> : null}
          </div>
          <div className="ms-auto">{actions}</div>
        </div>
        <div className="mt-3">{children}</div>
      </CardBody>
    </Card>
  );
};

DashCard.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  actions: PropTypes.node,
};

export default DashCard;
